import * as React from "react";
import { cn } from "@finster/ui";
import { ChevronDown, ChevronRight } from "lucide-react";

import type { SourceItem } from "../../ai/sourceItems";
import { getCitationColor } from "../../colors";

interface SourceGroupSectionProps {
  label: string;
  items: SourceItem[];
  children: React.ReactNode;
}

export const SourceGroupSection: React.FC<SourceGroupSectionProps> = ({
  label,
  items,
  children,
}) => {
  const [open, setOpen] = React.useState(true);
  const color = getCitationColor(label);

  return (
    <section className="flex min-w-0 flex-col">
      <h3 className="sr-only">
        {label}({items.length})
      </h3>
      <button
        type="button"
        onClick={() => setOpen((next) => !next)}
        className="flex w-full cursor-pointer items-center gap-2 rounded-md px-1.5 py-1.5 text-left transition-colors hover:bg-muted/40"
      >
        <span
          className="h-1.5 w-1.5 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
          aria-hidden
        />
        <span className="min-w-0 flex-1 truncate text-[12px] font-medium text-foreground">
          {label}
        </span>
        <span className="shrink-0 text-[10.5px] text-muted-foreground">
          {items.length} source{items.length === 1 ? "" : "s"}
        </span>
        <span className="shrink-0 text-muted-foreground/70">
          {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </span>
      </button>

      <div
        className={cn(
          "grid overflow-hidden transition-[grid-template-rows] duration-200 ease-out",
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        )}
      >
        <div className="min-h-0">
          <div className="flex min-w-0 flex-col gap-1.5 px-1.5 py-1.5">{children}</div>
        </div>
      </div>
    </section>
  );
};
